import { createContext } from 'react';

const myContext = createContext(null);

export default myContext;
